<script setup>
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
  delivery:         { type: Object, required: true },
  availableDrivers: { type: Array,  default: () => [] },
})
const emit = defineEmits(['close'])

const form = useForm({
  driver_id: props.delivery.driver?.id ?? '',
})

function submit() {
  form.transform(d => ({ delivery: d }))
      .patch(`/deliveries/${props.delivery.id}/reassign`, {
        preserveScroll: true,
        onSuccess: () => emit('close'),
      })
}
</script>

<template>
  <div class="overlay" @click.self="emit('close')">
    <div class="modal">
      <header class="modal__hdr">
        <h2 class="modal__title">Reassign driver</h2>
        <button class="modal__x" @click="emit('close')">×</button>
      </header>

      <form class="form" @submit.prevent="submit">
        <label class="field">
          <span class="field__label">Assign to driver</span>
          <select v-model="form.driver_id" class="field__select">
            <option value="">— Re-broadcast to all drivers —</option>
            <option v-for="d in availableDrivers" :key="d.id" :value="d.id">{{ d.name }}</option>
          </select>
          <span v-if="form.errors.driver_id" class="field__error">{{ form.errors.driver_id }}</span>
        </label>

        <div class="form__actions">
          <button type="button" class="btn" @click="emit('close')">Cancel</button>
          <button type="submit" class="btn btn--primary" :disabled="form.processing">
            {{ form.processing ? 'Saving…' : 'Reassign' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.overlay {
  position: fixed; inset: 0; z-index: 60;
  background: rgba(0,0,0,0.5);
  display: flex; align-items: center; justify-content: center; padding: 1rem;
}
.modal {
  background: var(--surface);
  border-radius: 0.75rem;
  padding: 1.25rem;
  width: 100%; max-width: 26rem;
  box-shadow: var(--shadow-lg, 0 20px 60px rgba(0,0,0,.25));
}
.modal__hdr {
  display: flex; justify-content: space-between; align-items: center;
  margin-bottom: 1rem;
}
.modal__title {
  font-size: 1rem; font-weight: 600; color: var(--ink); margin: 0;
}
.modal__x {
  background: none; border: 0; font-size: 1.5rem;
  color: var(--muted); cursor: pointer; line-height: 1;
}
.form { display: grid; gap: 0.875rem; }
.field { display: grid; gap: 0.3rem; }
.field__label { font-size: 0.8125rem; color: var(--inkSoft); }
.field__select {
  padding: 0.5rem 0.75rem;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius-input, 8px);
  color: var(--ink);
  font: inherit;
  font-size: 0.9375rem;
}
.field__error { font-size: 0.75rem; color: var(--danger); }
.form__actions { display: flex; gap: 0.5rem; justify-content: flex-end; margin-top: 0.25rem; }
.btn {
  padding: 0.45rem 0.85rem;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--ink);
  border-radius: var(--radius-button, 8px);
  cursor: pointer; font-weight: 500; font-size: 0.875rem;
}
.btn--primary {
  background: var(--accent); color: var(--accentInk); border-color: var(--accent);
}
.btn--primary:disabled { opacity: 0.5; cursor: not-allowed; }
</style>
